import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TranslationKey, useTranslator } from '@Localization';
import ClassNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Dropzone } from '../../../../design/dropzone/S_Dropzone';
import { Feedback } from '../../Feedback';

interface IProps {
  fileName?: string;
  fileValidationError?: TranslationKey;
  filesDropped: (acceptedOrRejected: File[]) => void;
}

export const WizardModalDropZoneContent = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <>
      <div>
        <p>
          {props.fileName ? (
            <span>
              {t('selected_file')}: <b>{props.fileName}</b>
            </span>
          ) : (
            <strong>{t('please_select_your_file')}</strong>
          )}
        </p>
        <p>
          <span>
            {t('our_json_format_documentation_can_be_found')}
            <a
              href='https://api.acdl.zebra.com/export-json-format.html'
              target='blank'
            >
              {' '}
              {t('here')}
            </a>
            .
          </span>
        </p>
        <p>{t('max_file_size')}</p>
        <S_Dropzone
          onDrop={props.filesDropped}
          className={ClassNames({ 'is-invalid': props.fileValidationError !== undefined })}
          multiple={false}
          accept={{ 'application/JSON': ['.json'] }}
        >
          <FontAwesomeIcon icon={faUpload} />
          {t('drop_your_json_file_here_or_select_it_manually')}
        </S_Dropzone>
        {props.fileValidationError && <Feedback feedbacks={[props.fileValidationError]} />}
      </div>
    </>
  );
});
